import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const isAuthenticated = (to, from, next) => {
  if (store.state.auth.isAuthenticated) {
    next();
    return;
  }
  next('/');
};

let routes = [
  //---catalog
  {
    path: '/:lang?/katalog/promo/:id/page/:page(\\d+)/',
    name: 'products-promo-paginated',
    component: () => import('@/modules/CatalogPages/CatalogPromo/index.vue')
  },
  {
    path: '/:lang?/katalog/promo/:id/',
    name: 'products-promo',
    component: () => import('@/modules/CatalogPages/CatalogPromo/index.vue')
  },
  {
    path: '/:lang?/katalog/page/:page(\\d+)/',
    name: 'products-paginated',
    component: () => import('@/modules/CatalogPages/Catalog/index.vue')
  },
  {
    path: '/:lang?/katalog/:brand?/:slug/',
    name: 'product',
    component: () => import('@/modules/Product/index.vue')
  },
  {
    path: '/:lang?/katalog/',
    name: 'products',
    component: () => import('@/modules/CatalogPages/Catalog/index.vue')
  },
  {
    path: '/:lang?/novinki/page/:page(\\d+)/',
    name: 'products-newest-paginated',
    component: () => import('@/modules/CatalogPages/CatalogType/index.vue')
  },
  {
    path: '/:lang?/novinki/',
    name: 'products-newest',
    component: () => import('@/modules/CatalogPages/CatalogType/index.vue')
  },
  {
    path: '/:lang?/top-prodazh/page/:page(\\d+)/',
    name: 'products-bestsellers-paginated',
    component: () => import('@/modules/CatalogPages/CatalogType/index.vue')
  },
  {
    path: '/:lang?/top-prodazh/',
    name: 'products-bestsellers',
    component: () => import('@/modules/CatalogPages/CatalogType/index.vue')
  },
  //---END catalog
  //---series brands
  {
    path: '/:lang?/product-category/:brandSeria?/:seria/page/:page(\\d+)/',
    name: 'brand-paginated',
    component: () => import('@/modules/Series/index.vue')
  },
  {
    path: '/:lang?/product-category/:brandSeria?/:seria/',
    name: 'brand',
    component: () => import('@/modules/Series/index.vue')
  },
  //---series collections
  {
    path: '/:lang?/product-collections/:seria/page/:page(\\d+)/',
    name: 'collection-paginated',
    component: () => import('@/modules/Series/index.vue')
  },
  {
    path: '/:lang?/product-collections/:seria/',
    name: 'collection',
    component: () => import('@/modules/Series/index.vue')
  },
  //---END series
  //---ingredients
  {
    path: '/:lang?/ingredienty/',
    name: 'ingredients',
    component: () => import('@/modules/Ingredients/index.vue')
  },
  {
    path: '/:lang?/ingredients/:slug/page/:page(\\d+)/',
    name: 'ingredient-paginated',
    component: () => import('@/modules/Ingredient/index.vue')
  },
  {
    path: '/:lang?/ingredients/:slug/',
    name: 'ingredient',
    component: () => import('@/modules/Ingredient/index.vue')
  },
  //---END ingredients
  //---selection
  {
    path: '/:lang?/podbor-kosmetiki/page/:page(\\d+)/',
    name: 'selection-paginated',
    component: () => import('@/modules/CatalogPages/Selection/index.vue')
  },
  {
    path: '/:lang?/podbor-kosmetiki/',
    name: 'selection',
    component: () => import('@/modules/CatalogPages/Selection/index.vue')
  },
  //---END selection
  //---outlet
  {
    path: '/:lang?/outlet/page/:page(\\d+)/',
    name: 'outlet-paginated',
    component: () => import('@/modules/CatalogPages/Outlet/index.vue')
  },
  {
    path: '/:lang?/outlet/',
    name: 'outlet',
    component: () => import('@/modules/CatalogPages/Outlet/index.vue')
  },
  //---END outlet
  //---blog
  {
    path: '/:lang?/news/page/:page(\\d+)/',
    name: 'news-paginated',
    component: () => import('@/modules/News/index.vue')
  },
  {
    path: '/:lang?/news/:slug/',
    name: 'news-single',
    component: () => import('@/modules/Article/index.vue')
  },
  {
    path: '/:lang?/news/',
    name: 'news',
    component: () => import('@/modules/News/index.vue')
  },
  {
    path: '/:lang?/interesnye-stati/page/:page(\\d+)/',
    name: 'interesting-paginated',
    component: () => import('@/modules/News/index.vue')
  },
  {
    path: '/:lang?/interesnye-stati/:slug/',
    name: 'interesting-single',
    component: () => import('@/modules/Article/index.vue')
  },
  {
    path: '/:lang?/interesnye-stati/',
    name: 'interesting',
    component: () => import('@/modules/News/index.vue')
  },
  {
    path: '/:lang?/video-materialy/page/:page(\\d+)/',
    name: 'videos-paginated',
    component: () => import('@/modules/Videos/index.vue')
  },
  {
    path: '/:lang?/video/:slug/',
    name: 'videos-single',
    component: () => import('@/modules/Video/index.vue')
  },
  {
    path: '/:lang?/video-materialy/',
    name: 'videos',
    component: () => import('@/modules/Videos/index.vue')
  },
  {
    path: '/:lang?/video-master-klassy/page/:page(\\d+)/',
    name: 'master-classes-paginated',
    component: () => import('@/modules/Videos/index.vue')
  },
  {
    path: '/:lang?/video-master-klassy/:slug/',
    name: 'master-classes-single',
    component: () => import('@/modules/Video/index.vue')
  },
  {
    path: '/:lang?/video-master-klassy/',
    name: 'master-classes',
    component: () => import('@/modules/Videos/index.vue')
  },

  //---END blog

  {
    path: '/:lang?/promotions/page/:page(\\d+)/',
    name: 'promotions-paginated',
    component: () => import('@/modules/Promotions/index.vue')
  },
  {
    path: '/:lang?/promotions/',
    name: 'promotions',
    component: () => import('@/modules/Promotions/index.vue')
  },
  {
    path: '/:lang?/reviews/',
    name: 'reviews',
    component: () => import('@/modules/Reviews/index.vue')
  },
  {
    path: '/:lang?/server-maintenance/',
    name: 'server-maintenance',
    component: () => import('@/modules/System/ServerMaintenance/index.vue')
  },
  {
    path: '/:lang?/server-error/',
    name: 'server-error',
    component: () => import('@/modules/System/ServerError/index.vue')
  },
  {
    path: '/:lang?/results/',
    name: 'results',
    component: () => import('@/modules/SearchCatalog/index.vue')
  },
  {
    path: '/:lang?/buy-flow/',
    name: 'buy-flow',
    redirect: '/:lang?/buy-flow/basket',
    component: () => import('../modules/buy-flow/index.vue'),
    children: [
      {
        path: 'basket/',
        name: 'buy-flow-basket',
        component: () => import('../modules/buy-flow/pages/basket/index.vue'),
        meta: {
          title: 'Корзина'
        }
      },
      {
        path: 'order/',
        name: 'buy-flow-order',
        component: () => import('../modules/buy-flow/pages/order/index.vue'),
        meta: {
          title: 'Оформлення замовлення'
        }
      }
    ]
  },
  //--------------------------------------pages--------------------------------------
  {
    path: '/:lang?/pages/:slug/',
    name: 'page',
    component: () => import('@/modules/StaticPages/StaticPage/index.vue')
  },
  {
    path: '/:lang?/contact/',
    name: 'contacts',
    component: () => import('@/modules/StaticPages/Contacts/index.vue')
  },
  {
    path: '/:lang?/about-us/',
    name: 'about-us',
    component: () => import('@/modules/StaticPages/About/index.vue')
  },
  {
    path: '/:lang?/delivery/',
    name: 'delivery',
    component: () => import('@/modules/StaticPages/DeliveryInfo/index.vue')
  },
  //--------------------------------------pages--------------------------------------
  {
    path: '/:lang?/profile/',
    redirect: '/:lang?/profile/user-info/',
    component: () => import('../modules/Profile/index.vue'),
    name: 'profile',
    beforeEnter: isAuthenticated,
    children: [
      {
        path: 'user-info/',
        name: 'profile-info',
        component: () => import('../modules/Profile/pages/user-info/index.vue')
      },
      {
        path: 'user-promo/',
        name: 'profile-promo',
        component: () => import('../modules/Profile/pages/ProfilePromo/index.vue')
      },
      {
        path: 'user-current-orders/',
        name: 'profile-current-orders',
        component: () => import('../modules/Profile/pages/CurrentOrders/index.vue')
      },
      {
        path: 'user-history-orders/',
        name: 'profile-history-orders',
        component: () => import('../modules/Profile/pages/HistoryOrders/index.vue')
      },
      {
        path: 'managers/',
        name: 'managers',
        meta: { title: 'менеджери' },
        component: () => import('../modules/Profile/pages/managers/index.vue')
      },
      {
        path: 'platform/',
        name: 'platform',
        component: () => import('@/modules/Profile/pages/platform/index.vue'),
        redirect: '/:lang?/profile/platform/seminars',
        children: [
          {
            path: 'seminars/',
            name: 'platform-seminars',
            component: () => import('@/modules/Profile/pages/platform/pages/seminars/index.vue')
          },
          {
            path: 'webinar/:id/',
            name: 'webinar',
            component: () => import('@/modules/Profile/pages/platform/pages/webinars/index.vue')
          },
          {
            path: 'webinar/:id/quiz/',
            name: 'quiz',
            component: () => import('@/modules/Profile/pages/platform/pages/test/index.vue')
          },
          {
            path: 'webinar/:id/quiz-result/',
            name: 'quiz-result',
            component: () => import('@/modules/Profile/pages/platform/pages/test-result/index.vue')
          }
        ]
      },
      {
        path: 'user-favorites/',
        name: 'profile-favorites',
        component: () => import('../modules/Profile/pages/ProfileFavorites/index.vue')
      },
      {
        path: 'user-professional-club/',
        name: 'user-professional-club',
        redirect: 'user-professional-club/clients-list',

        component: () => import('../modules/Profile/pages/professional-club/index.vue'),
        children: [
          {
            path: 'clients-list/',
            name: 'profile-clients-list',
            component: () => import('../modules/Profile/pages/professional-club/pages/clients-list/index.vue')
          },
          {
            path: 'client-history/:id/',
            name: 'profile-client-history',
            component: () => import('../modules/Profile/pages/professional-club/pages/client-history/index.vue')
          }
        ]
      },
      {
        path: 'distributor-orders/',
        name: 'distributor-orders',
        redirect: 'distributor-orders/moving',

        component: () => import('../modules/Profile/pages/distributor-orders/index.vue'),
        children: [
          {
            path: 'moving/',
            name: 'moving',
            meta: { title: 'Переміщення на склад' },
            component: () =>
              import('../modules/Profile/pages/distributor-orders/pages/distributor-orders-moving/index.vue')
          },
          {
            path: 'invoice/',
            name: 'invoice',
            meta: { title: 'Видаткові накладні' },

            component: () =>
              import('../modules/Profile/pages/distributor-orders/pages/distributor-orders-invoice/index.vue')
          }
        ]
      },
      {
        path: 'distributor-storage/',
        name: 'distributor-storage',
        redirect: 'distributor-storage/leftovers',

        component: () => import('../modules/Profile/pages/distributor-storage/index.vue'),
        children: [
          {
            path: 'leftovers/',
            name: 'leftovers',

            component: () =>
              import('../modules/Profile/pages/distributor-storage/pages/distributor-storage-leftovers/index.vue')
          },
          {
            path: 'sales/',
            name: 'sales',
            meta: { title: 'Продажі зі складу' },

            component: () =>
              import('../modules/Profile/pages/distributor-storage/pages/distributor-storage-sales/index.vue')
          },
          {
            path: 'report/',
            name: 'report',

            component: () =>
              import('../modules/Profile/pages/distributor-storage/pages/distributor-storage-report/index.vue')
          }
        ]
      }
    ]
  },
  //---tag
  {
    path: '/:lang(ua)?/:category([^ua][a-zA-Z0-9_-]+)/:tag([a-zA-Z0-9_-]+)/page/:page(\\d+)/',
    name: 'tag-paginated',
    component: () => import('@/modules/CatalogPages/CatalogTag/index.vue')
  },
  {
    path: '/:lang(ua)?/:category([^ua][a-zA-Z0-9_-]+)/:tag([a-zA-Z0-9_-]+)/',
    name: 'tag',
    component: () => import('@/modules/CatalogPages/CatalogTag/index.vue')
  },
  //---END tags
  {
    path: '/:lang(ua)?/',
    name: 'home',
    component: () => import('@/modules/Home/index.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'page-not-found',
    component: () => import('@/modules/System/PageNotFound/index.vue'),
    beforeEnter: (to, from, next) => {
      if (!to.path.endsWith('/')) {
        next({ path: `${to.path}/`, query: to.query, hash: to.hash });
      } else if (to.path === from.path) {
        if (to.name === 'page-not-found') {
          next();
        }
        return;
      } else {
        next();
      }
    }
  }
];

const addStrictOptionToRoutes = (routes) => {
  return routes.map((route) => {
    if (route.path !== '*') {
      if (!route.pathToRegexpOptions) {
        route.pathToRegexpOptions = { strict: true };
      }

      if (route.children && Array.isArray(route.children)) {
        route.children = addStrictOptionToRoutes(route.children);
      }
    }
    return route;
  });
};

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: addStrictOptionToRoutes(routes),
  scrollBehavior(to, from, savedPosition) {
    if (to.path !== from.path) {
      if (savedPosition) {
        return savedPosition;
      } else {
        let el = document.querySelector('.app');
        if (el) el.scrollTop = 0;
        return { x: 0, y: 0 };
      }
    }
  }
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => {
    if (!VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.duplicated)) throw err;
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch((err) => {
    if (!VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.duplicated)) throw err;
  });
};
export default router;
